import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import CategoryResultsModal from './CategoryResultsModal';
export default class CategoryResultCard extends Component {
  view() {
    const category = this.attrs.category;
    const award = this.attrs.award;
    const allNominees = category.nominees() || [];
    // Sort by vote count and show only top 3
    const nominees = [...allNominees].sort((a, b) => (b.voteCount() || 0) - (a.voteCount() || 0)).slice(0, 3);
    const canShowVotes = award.canShowVotes();
    const hasMoreNominees = allNominees.length > 3;
    return m("div", {
      className: "CategoryCard CategoryResultCard",
      id: `category-${category.id()}`
    }, m("div", {
      className: "CategoryCard-header"
    }, m("div", {
      className: "CategoryCard-headerMain"
    }, m("h2", null, category.name()), category.description() ? m("p", null, category.description()) : null), hasMoreNominees ? m(Button, {
      className: "Button Button--text CategoryResultCard-viewAll",
      onclick: () => {
        app.modal.show(CategoryResultsModal, {
          category,
          award
        });
      }
    }, app.translator.trans('huseyinfiliz-awards.forum.results.view_all')) : null), m("div", {
      className: "CategoryCard-grid"
    }, nominees.map((nominee, index) => {
      const isWinner = index === 0;
      const isRunnerUp = index === 1;
      const isThird = index === 2;
      return m("div", {
        className: `NomineeCard ${isWinner ? 'NomineeCard--winner' : ''}`,
        key: nominee.id()
      }, m("div", {
        className: "NomineeCard-image"
      }, nominee.imageUrl() ? m("img", {
        src: nominee.imageUrl(),
        alt: nominee.name()
      }) : m("div", {
        className: "NomineeCard-placeholder"
      }, m("i", {
        className: "fas fa-user"
      })), isWinner ? m("div", {
        className: "NomineeCard-badge NomineeCard-badge--gold"
      }, m("i", {
        className: "fas fa-medal"
      })) : null, isRunnerUp ? m("div", {
        className: "NomineeCard-badge NomineeCard-badge--silver"
      }, m("i", {
        className: "fas fa-medal"
      })) : null, isThird ? m("div", {
        className: "NomineeCard-badge NomineeCard-badge--bronze"
      }, m("i", {
        className: "fas fa-medal"
      })) : null), m("div", {
        className: "NomineeCard-content"
      }, m("h3", {
        className: "NomineeCard-title"
      }, nominee.name()), nominee.description() ? m("p", {
        className: "NomineeCard-description"
      }, nominee.description()) : null, isWinner ? m("div", {
        className: "TagLabel Label--success"
      }, app.translator.trans('huseyinfiliz-awards.forum.results.winner')) : null, isRunnerUp ? m("div", {
        className: "TagLabel Label--info"
      }, app.translator.trans('huseyinfiliz-awards.forum.results.runner_up')) : null, canShowVotes ? m("div", {
        className: "NomineeCard-stats"
      }, m("span", {
        className: "NomineeCard-votes"
      }, app.translator.trans('huseyinfiliz-awards.forum.results.votes', {
        count: nominee.voteCount()
      })), m("span", {
        className: "NomineeCard-percentage"
      }, app.translator.trans('huseyinfiliz-awards.forum.results.percentage', {
        percent: nominee.votePercentage()
      }))) : null));
    })));
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/CategoryResultCard', CategoryResultCard);